import { render, staticRenderFns } from "./LoanRules.vue?vue&type=template&id=24ff4d87&"
import script from "./LoanRules.vue?vue&type=script&lang=ts&"
export * from "./LoanRules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports